import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "../mockData";

const Fetch = {
  getLandingPageData: () =>
    mockData.shouldMock
      ? callMockResponse(mockData.getLandingPageData)
      : new FnrFetch3(`/Give/LandingPage`),

  getProfileGivingData: ({ userID, postData }) =>
    new FnrFetch3(`/user/${userID}/giving`, postData),

  getUserPledges: (postData) =>
    new FnrFetch3(`/pledge/getUserPledges`, postData),

  getUserRecurringGifts: (postData) =>
    new FnrFetch3(`/give/getUserRecurringGifts`, postData),
};

export const getCTAData = async () => {
  const endpoint = `/Giving/GivePageSettings/CTA?includeUserData=true`;

  const response = await new FnrFetch3(endpoint).get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getAlertData = async () => {
  const endpoint = `/Giving/Alerts`;

  const response = await new FnrFetch3(endpoint).get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export default Fetch;
